import { Api } from "@/models/class/api.class";
import { CashFlowReportResponse } from "@/models/interface/cash-flow-report/CashFlowReport.interface";
import { CashFlowReportFilterParams } from "@/models/interface/cash-flow-report/CashFlowReportFilterParams.interface";
import { ErrorResponseModel } from "@/models/interface/http.interface";
import { HttpClient } from "@/services/HttpClient.service";
import { AxiosError } from "axios";

class CashFlowReportService extends HttpClient {
  getReport(
    params: CashFlowReportFilterParams
  ): Promise<CashFlowReportResponse> {
    return this.get<CashFlowReportResponse>(Api.CashFlowReport, {
      params,
    })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  download(params: CashFlowReportFilterParams): Promise<Blob> {
    return this.get<Blob>(Api.DownloadCashFlowReport, {
      params,
      responseType: "blob",
    })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }
}

export const cashFlowReportService = new CashFlowReportService();
